import produce from 'immer';
import { IStepInfo, stepInfoInitalValues } from '../components/damageReportForm/stepInfo/stepInfo.schema';
import {
	IStepInfoAboutDamage,
	stepInfoAboutDamageInitialValues,
} from '../components/damageReportForm/stepInfoAboutDamage/stepInfoAboutDamage.schema';
import {
	IStepPaymentInfo,
	stepPaymentInfoInitalValues,
} from '../components/damageReportForm/stepPaymentInfo/stepPaymentInfo.schema';
import {
	DAMAGE_REPORT_OPTIONS_SELECTED,
	STEP_INFO_ABOUT_DAMAGE_FULFILLED,
	STEP_INFO_FULFILLED,
	STEP_PAYMENT_INFO_FULFILLED,
	SUBMIT_REPORT_FAILED,
	SUBMIT_REPORT_FULFILLED,
	SUBMIT_REPORT_PENDING,
} from '../constants/actions/damageReportActions';

export interface IDamageReportReducer {
	stepInfoAboutDamage: IStepInfoAboutDamage;
	stepInfo: IStepInfo;
	stepPaymentInfo: IStepPaymentInfo;
	submissionLoading: boolean;
	submissionFulfilled: boolean;
	submissionFailed: boolean;
	errorMessage: string;
}

const initialValues: IDamageReportReducer = {
	stepInfoAboutDamage: stepInfoAboutDamageInitialValues,
	stepInfo: stepInfoInitalValues,
	stepPaymentInfo: stepPaymentInfoInitalValues,
	submissionLoading: false,
	submissionFulfilled: false,
	submissionFailed: false,
	errorMessage: '',
};

const damageReportReducer = produce((draft: IDamageReportReducer, action) => {
	switch (action.type) {
		case DAMAGE_REPORT_OPTIONS_SELECTED: {
			const updatedObject = stepInfoAboutDamageInitialValues;
			updatedObject.damageType = action.payload.values;
			const payloadValues: IStepInfoAboutDamage = updatedObject;
			draft.stepInfoAboutDamage = payloadValues;
			break;
		}
		case STEP_INFO_ABOUT_DAMAGE_FULFILLED: {
			const payloadValues: IStepInfoAboutDamage = action.payload.values;
			draft.stepInfoAboutDamage = payloadValues;

			const updatedStepInfoInitalValues = action.payload.stepInfoValues;
			updatedStepInfoInitalValues.whoFillsOut = action.payload.values.whoFillsOut.value;
			draft.stepInfo = updatedStepInfoInitalValues;
			break;
		}
		case STEP_INFO_FULFILLED: {
			const payloadValues: IStepInfo = action.payload.values;
			draft.stepInfo = payloadValues;
			break;
		}
		case STEP_PAYMENT_INFO_FULFILLED: {
			draft.stepPaymentInfo = action.payload.values;
			break;
		}
		case SUBMIT_REPORT_PENDING: {
			draft.submissionLoading = true;
			draft.submissionFailed = false;
			break;
		}
		case SUBMIT_REPORT_FULFILLED: {
			draft.submissionLoading = false;
			draft.submissionFulfilled = true;
			draft.submissionFailed = false;
			break;
		}
		case SUBMIT_REPORT_FAILED: {
			draft.submissionLoading = false;
			draft.submissionFailed = true;
			draft.submissionFulfilled = false;
			draft.errorMessage = action.payload.errorMessage;
			break;
		}
		default: {
			break;
		}
	}
}, initialValues);

export default damageReportReducer;
